export default "/assets/images/problem-solved-08.b37a64ba3bef5bc3.png";